import { DateFields, DatePresets, Services, alignReportManagerQueuePayloadDateRangeByDays, sanitizeReportManagerQueuePayloadDateRange } from '@sigma-frontend-libs/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: `${Services['report-manager/queue']}`,

      backendGeneration: 'nest',

      outputFilter(data) {
        return alignReportManagerQueuePayloadDateRangeByDays(sanitizeReportManagerQueuePayloadDateRange(data))
      },

      find: {
        defaultFilter: {
          name: undefined,
          type: undefined,
          status: undefined,
          ownerId: undefined,
          createdAtPreset: DatePresets['current.month'],
          createdAt: {
            gte: undefined,
            lt: undefined
          }
        },
        defaultOrder: {
          orderField: DateFields.createdAt,
          orderDirection: OrderDirections.DESC
        }
      },

      update: false,

      has: {
        tabs: false,
        clone: false,
        support: false
      },

      formClass: '',
      titlePath: 'name'
    })
  ]
}
